import { render } from "./homeEduResearch.vue?vue&type=template&id=675f38ff&scoped=true"
import script from "./homeEduResearch.vue?vue&type=script&lang=js"
export * from "./homeEduResearch.vue?vue&type=script&lang=js"

import "./homeEduResearch.vue?vue&type=style&index=0&id=675f38ff&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675f38ff"]])

export default __exports__